export enum uploadActionTypes {
  START = "START",
  UPLOADING = "UPLOADING",
  PROCESSING = "PROCESSING",
  FETCHING = "FETCHING",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  NOT_A_LOG_FILE = "NOT_A_LOG_FILE",
  WEBSOCKET_PROGRESS = "WEBSOCKET_PROGRESS",
  WEBSOCKET_COMPLETE = "WEBSOCKET_COMPLETE",
  WEBSOCKET_ERROR = "WEBSOCKET_ERROR"
}

export const USER_AUTH_KEY = "UserAuth";
export const USER_THEME_KEY = "UserTheme";
export const USER_COLOR_KEY = "UserColor";
export const COOKIE_CONSET_KEY = "CookieConsent";

export enum DataPipelineStates {
  T1_INIT,
  T1_DONE,
  T2_PROCESSING,
  T2_DONE,
  T2_ERROR,
  TS_NOT_A_LOG_FILE
}

export const chartHeight: number = 200;

export const fpsAxisDefaultMax: number = 60;

export const lineWidth: number = 2;

export enum GoogleAnalyticsEventCategories {
  BENCHMARKS = "Benchmarks",
  REPORT = "Report",
  CHARTS = "Charts",
  PAYMENT = "Payment",
  ANALYSIS = "Analysis"
}

/* warning, this is copied over from the backend processing code layer constants. It needs to be kept in sync */
export const maxCrowdedness: number = 3500;

export const paypalButtonId: string = "2S9D4YLEKXXU6";
